var render = function render(){var _vm=this,_c=_vm._self._c,_setup=_vm._self._setupProxy;return (_vm.question.params.rte_title)?_c(_setup.RichText,{attrs:{"content":_setup.title}}):_c('span',[_vm._v(_vm._s(_setup.title))])
}
var staticRenderFns = []

export { render, staticRenderFns }